import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// Actions
import {
  fetchExportStudyCSV,
  toggleExportCsvDialog,
  setVirtualKeyboard,
} from "../../actions";

// MUI Components
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import InputAdornment from "@material-ui/core/InputAdornment";
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import Collapse from "@material-ui/core/Collapse";
import FormHelperText from "@material-ui/core/FormHelperText";
import Input from "@material-ui/core/Input";
import InputBase from "@material-ui/core/InputBase";
import FormControl from "@material-ui/core/FormControl";
import Box from "@material-ui/core/Box";
//Icons
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import FolderIcon from "@material-ui/icons/Folder";
// Other Files
import { customTheme } from "../../constants/customTheme";
import classNames from "classnames";
import VirtualKeyboard from "../Shared/VirtualKeyboard";

const useStyles = makeStyles({
  root: (props) => customTheme(props.theme).dialog.root,
  buttonContainer: customTheme().dialog.buttonContainer,
  title: customTheme().dialog.title,
  contentContainer: (props) => ({
    ...customTheme().dialog.contentContainer,
    ...customTheme(props.theme).customScrollBar,
    overflowY: "auto",
  }),
  contentItem: customTheme().dialog.contentItem,
  contentItemPadding: customTheme().dialog.contentItemPadding,

  buttonOutlined: (props) => ({
    width: "110px",
    ...customTheme(props.theme).buttonOutlined,
  }),
  buttonProgress: (props) => customTheme(props.theme).buttonProgress,
  buttonExport: (props) => ({
    width: "170px",
    minHeight: "36.5px",
    ...customTheme(props.theme).buttonPrimary,
  }),
  formText: customTheme().formText,
  collapseIcon: customTheme().collapseButton,
  fileIcon: (props) => customTheme(props.theme).iconButton,
  studyDropdown: {
    display: "flex",
    ...customTheme().dialog.contentItem,
    margin: "5px 10px 5px 10px",
  },
  studyListItem: {
    paddingTop: "0px 0px 0px 7px",
  },
  progressCircle: {
    marginRight: "15px",
    color: "rgba(255,255,255,1)",
  },
  progressLabel: {
    fontSize: "0.9rem",
  },
});

const ExportCsvDialog = (props) => {
  const classes = useStyles(props);

  const [localState, setLocalState] = React.useState({
    openAccordian: false,
    fileName: props.selectedParticipantId.replace(/ /g, "_"),
    filePath: props.reviewSavePath,
    selectedStudies: Object.keys(props.reviewStudies),
  });

  const [keyboardInput, setKeyboardInput] = React.useState({
    inputName: "fileName",
    inputUpdate: { fileName: "" },
  });

  // Circular progress value
  const [progressIndicator, setProgressIndicator] = React.useState(0);

  // useEffect(() => {
  //   props.eventSource.addEventListener("progress_indicator", handleEvent);
  //   return () => {
  //     props.eventSource.removeEventListener("progress_indicator", handleEvent);
  //   };
  // }, []);

  const handleEvent = (e) => {
    switch (e.type) {
      case "progress_indicator":
        setProgressIndicator(JSON.parse(e.data) * 100);
        break;
      default:
    }
  };
  const handleExport = () => {
    props.setVirtualKeyboard(false);

    props.fetchExportStudyCSV(
      localState.selectedStudies,
      localState.filePath + "/" + localState.fileName + ".csv"
    );
  };

  const handleFileExplorer = () => {
    // const { dialog } = window.require("electron").remote;
    // const defaultPath = localState.filePath.split("/").join("\\");
    // dialog.showOpenDialog(
    //   {
    //     defaultPath: defaultPath,
    //     properties: ["openDirectory"],
    //   },
    //   (filePaths) => {
    //     if (filePaths !== undefined && filePaths.length !== 0) {
    //       let newPath = filePaths[0].split("\\").join("/");
    //       setLocalState({ ...localState, filePath: newPath });
    //     }
    //   }
    // );
  };

  const handleTextFieldChange = () => (event) => {
    setLocalState({ ...localState, fileName: event.target.value });
    setKeyboardInput({
      ...keyboardInput,
      inputUpdate: { fileName: event.target.value },
    });
  };
  const handleStudySelect = (event, studyId) => {
    let newSelecteds;
    if (event.target.checked) {
      newSelecteds = [...localState.selectedStudies, studyId];
    } else {
      newSelecteds = localState.selectedStudies.filter((id) => {
        return id !== studyId;
      });
    }
    setLocalState({ ...localState, selectedStudies: newSelecteds });
  };
  return (
    <Dialog
      open={props.open}
      onExiting={() => props.setVirtualKeyboard(false)}
      PaperProps={{ className: classNames(classes.root) }}
      disableBackdropClick={true}
    >
      <Typography
        className={classes.title}
        variant="h4"
        color="textPrimary"
        align="center"
      >
        Export Studies as CSV
      </Typography>

      <DialogContent className={classes.contentContainer}>
        <div className={classes.studyDropdown}>
          <IconButton
            className={classes.collapseButton}
            size="small"
            onClick={(e) =>
              setLocalState({
                ...localState,
                openAccordian: !localState.openAccordian,
              })
            }
          >
            {localState.openAccordian ? (
              <KeyboardArrowUpIcon />
            ) : (
              <KeyboardArrowDownIcon />
            )}
          </IconButton>
          <Typography
            className={classes.contentItem}
            color="textPrimary"
            align="center"
          >
            {localState.selectedStudies.length} Studies selected
          </Typography>
        </div>
        <Collapse
          style={{
            minHeight: "auto",
          }}
          collapsedHeight={"0px"}
          in={localState.openAccordian}
        >
          <List>
            {Object.keys(props.reviewStudies).map((studyId) => (
              <ListItem className={classes.studyListItem} key={studyId}>
                <ListItemIcon>
                  <Checkbox
                    color="primary"
                    onChange={(event) => handleStudySelect(event, studyId)}
                    checked={localState.selectedStudies.includes(studyId)}
                    value={studyId}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={
                    props.reviewStudies[studyId].studyInfo.studyDate +
                    ", " +
                    props.reviewStudies[studyId].studyInfo.protocolName
                  }
                />
              </ListItem>
            ))}
          </List>
        </Collapse>

        <InputBase
          className={classes.contentItemPadding}
          value={localState.filePath}
          fullWidth
          multiline
          rowsMax={2}
          readOnly
          startAdornment={
            <InputAdornment position="start">
              <IconButton
                className={classes.fileIcon}
                onClick={handleFileExplorer}
              >
                <FolderIcon />
              </IconButton>
            </InputAdornment>
          }
          inputProps={{
            className: classes.formText,
          }}
        />

        <FormControl
          onFocus={() => {
            props.setVirtualKeyboard(true);
          }}
          className={classes.contentItemPadding}
          fullWidth
        >
          <Input
            value={localState.fileName}
            onChange={handleTextFieldChange()}
            endAdornment={<InputAdornment position="end">.csv</InputAdornment>}
            inputProps={{
              className: classes.formItem,
            }}
          />
          <FormHelperText>File Name</FormHelperText>
        </FormControl>
      </DialogContent>

      <DialogActions className={classes.buttonContainer}>
        <Button
          disabled={props.requestExportPdf}
          onClick={() => props.onClose()}
          className={classes.buttonOutlined}
          variant="outlined"
        >
          Cancel
        </Button>
        <Button
          onClick={() => handleExport()}
          className={classes.buttonExport}
          variant="contained"
          color="primary"
          disabled={
            props.requestExportCsv || localState.selectedStudies.length === 0
          } // Disabled CSV export if there are no studies selected
        >
          {props.requestExportCsv ? (
            <Box
              className={classes.progressCircle}
              position="relative"
              display="inline-flex"
            >
              <CircularProgress
                size={38}
                variant="static"
                value={progressIndicator}
              />
              <Box
                top={0}
                left={0}
                bottom={0}
                right={0}
                position="absolute"
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Typography
                  className={classes.progressLabel}
                  variant="caption"
                  component="div"
                >{`${Math.round(progressIndicator)}%`}</Typography>
              </Box>
            </Box>
          ) : (
            "Export CSV"
          )}
        </Button>
      </DialogActions>

      <VirtualKeyboard
        anchor={"center"}
        keyboardInitialInput={{ fileName: localState.fileName }}
        keyboardInputUpdate={keyboardInput.inputUpdate}
        keyboardInputName={keyboardInput.inputName}
        keyboardChange={(event) =>
          setLocalState({ ...localState, fileName: event })
        }
      />
    </Dialog>
  );
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      fetchExportStudyCSV,
      toggleExportCsvDialog,
      setVirtualKeyboard,
    },
    dispatch
  );
};

const mapStateToProps = (state) => {
  return {
    // reviewMode: state.view.viewId === viewIds.reviewMode,
    studyId: state.studyInfo.id,
    studySaved: state.studyInfo.studySaved,
    reviewSavePath: state.availableParticipants.reviewSavePath,
    studySavePath: state.studyInfo.studySavePath,
    participantId: state.studyInfo.participantId,
    selectedParticipantId: state.availableParticipants.selectedParticipantId,
    reviewStudies: state.availableParticipants.reviewStudies,
    requestExportCsv: state.utility.requestExportCsv,
    theme: state.utility.theme,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExportCsvDialog);
